import { render, staticRenderFns } from "./EncounterPatientPage.vue?vue&type=template&id=0270da92&scoped=true&"
import script from "./EncounterPatientPage.vue?vue&type=script&lang=js&"
export * from "./EncounterPatientPage.vue?vue&type=script&lang=js&"
import style0 from "./EncounterPatientPage.vue?vue&type=style&index=0&id=0270da92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0270da92",
  null
  
)

export default component.exports